import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { categoriesActions } from "../../../../redux/actions/categories";
import EditCategories from "./edit";

const mapStateToProps = state => {
  return {
    catregory: state.category,
    catList: state.categoryReducer.cviews,
    catDetail: state.categoryDetailReducer.items,
    catStatus: state.categoryReducer.update,
    error: state.categoryReducer,
    parentcatdata: state.categoryDetailReducer.parentcatdata
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...categoriesActions
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCategories);



// WEBPACK FOOTER //
// ./src/app/views/admin/categories/editcategories/index.js